import { useEffect } from "react";
import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import { useUploadEcasFileMutation } from "../../../services/bl-import/BLImportService";
import { useAppSelector } from "../../../store/hooks";
import UploadEcas from "../forms/UploadEcas";

interface props {
  idBl?: number;
  onClose: () => void;
  callback: () => void;
}

const DialogUploadEcas = ({ idBl, onClose, callback }: props) => {
  const { userInfo } = useAppSelector((state) => state.auth);
  const [uploadFile, { isSuccess, isError, isLoading, reset }] =
    useUploadEcasFileMutation();
  const onSubmit = (file: File) => {
    uploadFile({
      file: file,
      id_bl: String(idBl),
      id_usuario: userInfo?.id!,
    });
  };

  const handleClose = () => {
    onClose();
    setTimeout(reset, 200);
  };

  useEffect(() => {
    if (isSuccess === true) {
      callback();
    }
    return;
  }, [isSuccess, callback]);

  return (
    <CustomDialog
      isOpen={Boolean(idBl)}
      handleClose={handleClose}
      title="Subir Ecas"
      hideActionButtons
      isSuccess={isSuccess}
      successMessage="Se subio el Ecas correctamente"
      isError={isError}
      errorMessage="Ocurrio un error. Intente luego."
    >
      <UploadEcas
        isLoading={isLoading}
        onSend={onSubmit}
        onClose={handleClose}
      />
    </CustomDialog>
  );
};

export default DialogUploadEcas;
